import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  DoItemUserAction({}, params) {
    return new Promise((resolve, reject) => {
      get("action/v2/item/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  DoItemRateAction({}, params) {
    return new Promise((resolve, reject) => {
      post("action/user/item_rate/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
